import React, { Component } from 'react'
import { Link } from 'gatsby'
import EventTracker from './../../helpers/EventTracker'
import { buildURL } from '../../utils/url'

export default class BannerWidget extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { className, data } = this.props
        const { title, description, backgroundImage, textButton, internalPage, externalLink, fullWidth } = data
        return (
            <div className={`banner-widget ${fullWidth ? ' ' : 'no-fullwidth'}`}>
                <div className={`banner ${className || ''}`} style={{ backgroundImage: `url(${backgroundImage?.file?.url})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                    <div className="banner-content">
                        <div className="banner-text">
                            <h2>{title}</h2>
                        </div>

                        <div className="banner-action">
                            {description && description.description && <p>{description.description}</p>}
                            <Link to={internalPage ? buildURL(internalPage) : externalLink} className="banner-link" target={externalLink ? '_blank' : undefined} rel={externalLink ? 'noopener noreferrer' : undefined} onClick={() => this.trackClick()}>
                                <span className="banner-link-text">{textButton || 'View More'}</span>
                                <i className="fa fa-arrow-right view-more-icon" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    trackClick() {
        EventTracker.customEvent(EventTracker.EVENT_CATEGORIES.BANNER_WIDGET, EventTracker.EVENT_TYPES.CLICK, 'BANNER_LINK')
    }
}
